import cx from 'classnames';

import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';

import styles from './ClientCapabilities.module.scss';

const CAPABILITIES = [
  'Read your workspaces and brand voices',
  'Score copy and read its insights',
  'Improve copy',
  'Save copy to Anyword',
];

interface ClientCapabilitiesProps {
  className?: string;
  clientName: string;
}

export const ClientCapabilities = ({ className, clientName }: ClientCapabilitiesProps) => (
  <section
    className={cx(styles.root, className)}
    data-testid="oauthConsentCapabilities"
  >
    <CustomTypography variant={TYPOGRAPHY_VARIANT.semiBold14}>
      {clientName} will be able to:
    </CustomTypography>
    <ul className={styles.list}>
      {CAPABILITIES.map((capability) => (
        <li key={capability}>
          <CustomTypography variant={TYPOGRAPHY_VARIANT.regular14}>{capability}</CustomTypography>
        </li>
      ))}
    </ul>
  </section>
);
